// The backend's only documented 403 case for /auth/login and /auth/refresh
// is a plan/brand mismatch, worded as "...not permitted to access <brand>."
// There's no dedicated error code for it yet, so this matches on the shared
// part of that wording — fragile if the copy changes, but the best signal
// available until backend exposes something more stable. Any 403 that
// doesn't match this is treated as an unrelated rejection (disabled account,
// etc.), not assumed to be a brand mismatch.
const WRONG_BRAND_ERROR_PATTERN = /not permitted to access/i;

export const isWrongBrandApiError = (errors: string[]): boolean =>
  errors.some((error) => WRONG_BRAND_ERROR_PATTERN.test(error));
